import React from "react";

export default (options) => (
	<section id="numbers">
		<div className="section_title">
			<p>NUMBERS</p>
			<h2>ライゾンを数字で見る</h2>
		</div>
		<div className="section_contents">
			<div className="numbers_contents">
				<div className="numbers_item num_member">
					<div className="title">
						<p>従業員数</p>
					</div>
					<div className="item icon-brackets">
						<p className="number">
							<span className="count">
								{options.counterNumber}
							</span>
							名
						</p>
					</div>
				</div>
				<div className="numbers_item num_age">
					<div className="title">
						<p>平均年齢</p>
					</div>
					<div className="item">
						<div className="icon-brackets">
							<p className="number">
								<span className="count">
									{options.ageNumber}
								</span>
								歳
							</p>
						</div>
						<div className="graph">
							<p className="text">５０代～</p>
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<p className="number percent">
								<span className="count">
									{options.ageNumber50}
								</span>
								%
							</p>
						</div>
						<div className="graph">
							<p className="text">４０代</p>
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<p className="number percent">
								<span className="count">
									{options.ageNumber40}
								</span>
								%
							</p>
						</div>
						<div className="graph">
							<p className="text">３０代</p>
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<p className="number percent">
								<span className="count">
									{options.ageNumber30}
								</span>
								%
							</p>
						</div>
						<div className="graph">
							<p className="text">２０代</p>
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<p className="number percent">
								<span className="count">
									{options.ageNumber20}
								</span>
								%
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="numbers_viewmore">
				<p className="numbers_viewmore_btn">view more</p>
			</div>
			<div className="numbers_viewmore_content">
				<div className="numbers_contents">
					<div className="numbers_item num_gender">
						<div className="title">
							<p>男女比</p>
						</div>
						<div className="item">
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<div className="man">
								<svg
									className="svgIllust"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 39.12 136.31"
								>
									<title />
									<path d="M39.12,44.83c0-.76-2-7.45-2-7.45.15-.45-1.83-4.1-2.13-5.16s.46-1.83-.45-2.13-1.07-2.28-1.68-3.34-3.49-5.47-3.49-5.47c-.76-.92-2,.11-2.85.22s-4.64-1.44-4.64-1.44l-.45-.68a4.7,4.7,0,0,0-2.05-1.15l-1.6-1.59a11.16,11.16,0,0,0,.57-4.33c-.11-.8.23-1.25.57-2.62s-.23-3.31.42-3.16-1.22-3-2.74-4.4a3.48,3.48,0,0,0-2.88-1.07L14.2,0a15.56,15.56,0,0,1-3.34.46A3.07,3.07,0,0,0,8,3.34,6,6,0,0,0,5,9.46c.69,4.22.57,3,.57,3a8.46,8.46,0,0,0,1.26,2.51c.57.46,2.28,3.3,3,3.65s0,.45,0,.45.8,1.94.91,2.4a4.18,4.18,0,0,1-.34,1.71,17.86,17.86,0,0,1-4.22,3.3c-1.25.57-2.28.46-2.5,1.48s-1,6.84-1.26,8.55-1,5-1,5.47A4.3,4.3,0,0,1,1.17,44c-.34.45-1.37,1.13-.91,1.48s.8,1.37.57,1.71A5,5,0,0,0,0,48.78,13.55,13.55,0,0,0,.6,53.34a13.1,13.1,0,0,1,.68,3.19c.12.69,0,2.63.8,3.76s1.25,1.26,1.25,1.26a12.53,12.53,0,0,0,2.62,1h.58s-.23,8.32.22,8.55,1.71-.34,1.71-.34,1.94,15,3.65,18.47a28.26,28.26,0,0,0-.34,5.35c.11,1,1.48,30.89,1.48,31.69a10.7,10.7,0,0,0,.46,2.28s-.46,1.37-1,1.48a15.58,15.58,0,0,1-4,.23c-.79-.23-2.62,1.36-.68,2.16a8.72,8.72,0,0,0,2.5.8s-2.16,2.62-1.13,2.85,8.32.34,9.12,0S19.75,135,20.09,135s1.6-.11,1.82-.8a4.33,4.33,0,0,0,.23-1.25s5,.8,5.47,0a3.19,3.19,0,0,0,.12-2.05s-.46-3.88-1-4.9-.11-1.71-.23-2.4-1.14-23-2.62-27.69.46-13.45.8-14.94L27.16,70s1.25-.34,1.25-.68c0-.15-.19-3.58-.41-7.49,2.3-2.88,8.38-10.5,9-11.35A20.06,20.06,0,0,0,39.12,44.83Zm-8,3.34-1.82,1.68s-.76,1.52-1.52,1.82c0,0-.12-.48-.15-.46-.06-1.13-.2-.78-.2-1V45.7c0-.91-.21-7.22.91-8.09.5-.38,1.16,2.71,1.56,3.73l.61,3.19,1.07,2Z" />
								</svg>
								<p className="text">男性</p>
								<p className="number percent">
									<span className="count">
										{options.genderMan}
									</span>
									%
								</p>
							</div>
							<div className="woman">
								<svg
									className="svgIllust"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 49.42 160.56"
								>
									<title />
									<path d="M45.62,33.1c-.2-.79-.2-1.38-.79-1.77-.39-1-.2-2.76-1.18-3.16s-5.13-1.77-5.13-1.77c3.16-4.14.2-8.08,1.38-10.64s-1.18-6.51-2.16-8.87A7.32,7.32,0,0,0,28.87.19c-4.14,1-4.34,3.15-4.34,3.15C23.15,3.74,20,6.89,20.79,11s3.35,7.69,2.56,9.85a2.65,2.65,0,0,1-3.15,1.58A4.6,4.6,0,0,0,22,24.23s-4.93,2-5.91,3.16a3,3,0,0,0-2.37,2.95,11.91,11.91,0,0,1-.39,3.75s-.79,1.77-.2,2.36-.39,9.46.79,12.22A17.73,17.73,0,0,0,16.45,53l-1,3.74-2,4.93a1.44,1.44,0,0,0,1,.59s-3.35,10-2.56,10.25,3.15.59,3.15.59-2,5.91-.19,14.58c1.7,8.34,1.37,11.63,1.37,13v1.38l.56,0c-.68,3.83-1.55,8.76-1.55,9.23,0,.79-2,6.51-2.55,11.83s-2.37,19.51-3.16,21.28-5.32,9.86-6.5,10.84-3.55,3.94-3,4.14,2.17,2.17,5.72.39,5.32-6.3,5.71-6.89.6,1.57.6,1.57h1a6.21,6.21,0,0,1,.2-1.57c.2-.59,1.38-2.76,1.38-4.54a20.93,20.93,0,0,0-.59-4.13s5.32-11.63,6.3-16.16,2.26-11,2.26-13.37c0-.66,1.85-7.06,3.43-12.4l2,0,.54,0a57.63,57.63,0,0,0,.25,6.53c.39,2.17-2.17,5.32-1.78,17s-1.18,17.15-1.18,17.15-1.38,3.54-.79,4.92.2,5.13.2,5.13.39,1.38,1.38,1.18l.39-1.18s1.19,2.76,3.16,3.55,5.32,1.77,6.11.59-4.93-9.66-5.13-11.83,5.32-23.65,4.34-30.15c.32-3.72,1.32-8.92,2.21-13.4l2.91-.2s3-24.44,2.56-27.59a2.22,2.22,0,0,1,1.78-1L43.45,57.15s5.32-1,5.91-3S45.82,33.89,45.62,33.1Z" />
								</svg>
								<p className="text">女性</p>
								<p className="number percent">
									<span className="count">
										{options.genderWoman}
									</span>
									%
								</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_recruit">
						<div className="title">
							<p>採用比</p>
						</div>
						<div className="item">
							<div className="bar">
								<div className="bar_inner" />
							</div>
							<div className="mid">
								<svg
									className="svgIllust"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 70.06 121.41"
								>
									<title />
									<path d="M10.69,93a6.52,6.52,0,0,1,2.79-1.2s.37-.1,1.39.83c0,0,.84.47,1,.37s2.18,4.28,2.32,4.7L20.63,103a55.1,55.1,0,0,1,1.47,6.92c0,.06,0,.13,0,.19.28,2.79,1.53,4,1.95,4.27,0,0,2.46,2.24-1.21,2.19l.33,2.14s0,1.34-1.16,1.48c0,0-1.26.51-1.81-1.86,0,0-.61-5.85-.89-6.87,0,0-.37-2.37-1.06-2.32,0,0-.47-.56-.24,2.27,0,0,.7,7,.47,8.6a1.58,1.58,0,0,1-1.44,1.44,1.71,1.71,0,0,1-1.4-1.86s-1.76,1.72-2.22-2.09c0,0-.56-7.3-.84-8.41a40.7,40.7,0,0,0-.42,6.41s-.28,1.25-1,1.35c0,0-1,.23-1.17-2.74,0,0-.14-8.69-.23-10.22,0,0-.51-6.23-1.25-4.6C8.56,99.25,7.4,95,10.69,93Z" />
									<path d="M35.3,45.43a8.61,8.61,0,0,1,3.27,2s.94,1.13-1.12,2.63c0,0,3.24,7.47.34,8.81l-3.67-4.56,1-4.06a23.69,23.69,0,0,0-2-2.71S33.26,46.13,35.3,45.43Z" />
									<path d="M24.07,73.56s1.29,2.08,2.57,4c6.2,4.57,16,10.5,16,10.5,5.94,7.38,8.46,6.42,8.46,6.42,4.08.06,4.93-2,4.93-2A42.91,42.91,0,0,1,60.41,87c4.74-7.57,7.53-16.49,8.75-21-.13-1-.28-1.68-.28-1.68-.18-2,1-10.31,1-10.31a18.13,18.13,0,0,0-.18-6.44c-.82-2.94-4-5.73-4-5.73-6.91-6.37-16.47-10.56-16.47-10.56a8.54,8.54,0,0,0-2.52-1l0-.07a7.3,7.3,0,0,1-1.07-3.9,6.46,6.46,0,0,0,2-1.65A3.31,3.31,0,0,0,49,22.39c.08-.5.33-2.22.33-2.22a6,6,0,0,0-.79-3,33,33,0,0,1-.82-6.55,1.09,1.09,0,0,1,0-.18,9.24,9.24,0,0,0-2.57-5.76L43.07,2.63C40.35.12,38.84.51,38.84.51A2,2,0,0,0,37.05,1a2.27,2.27,0,0,0-1.86-1A13,13,0,0,0,29,1a12.44,12.44,0,0,0-4,3.1S22.4,7.24,20.4,9.28a8.5,8.5,0,0,0-1.62,5.62,3.61,3.61,0,0,0,1.9.19s.75,0,.79,1.85a7.48,7.48,0,0,0,1.07,2s1.81,5.81,2.4,7.19a1.16,1.16,0,0,0,.06.15,40.44,40.44,0,0,0,2.93,7.89A11.86,11.86,0,0,1,26,36a42.75,42.75,0,0,1-4.59-.6S19,35,18.13,38.54c0,0-12.82,30.75-13.43,31.12v1.91s-2,.74-3.06,4L.48,76.77S-.08,77,0,79.19c0,0,.6,11.33,1,12.91a5.07,5.07,0,0,0,1.39,3,4.58,4.58,0,0,0,2.46,1.11s-1.3-3.3,1.49-5c0,0,2.88-2.37,4-2.46,0,0,1.3-.79,3.25.46a3.63,3.63,0,0,0,2,.75s-.38-1-.84-2.09a4,4,0,0,1,1-4.14s.74-.41.74-2.88l.84-1a9.29,9.29,0,0,1,1-4.69,20.23,20.23,0,0,1,3-4.23s.41-.19.41-1.72l1.21-.19A15.41,15.41,0,0,0,24.07,73.56ZM17.66,51.23s-.16.41-.4-2.66a10.5,10.5,0,0,1,.4-3.14S17.52,48.9,17.66,51.23ZM52.27,64.31a11.7,11.7,0,0,1,.35-6.16c-.07,5.87.58,6.16.58,6.16-1.65,2.43-4.16,9-4.16,9-.78-.93-2.5-2.72-2.5-2.72,1.57.5,2.22.64,2.22.64C50.4,67.53,52.27,64.31,52.27,64.31ZM21.36,40.92c.76-1.82,2-1.63,2-1.63a2.1,2.1,0,0,1,1.78,1.47c4.43-.37,4.48,6.66,4.48,6.66-1.42-7.33-4.83-5.83-4.83-5.83-.51-1.61-1.43-1.71-1.43-1.71-1.18,0-1.71,1.63-1.71,1.63-2.26-.29-2.93,2.18-2.93,2.18C18.76,40.68,21.36,40.92,21.36,40.92Zm-.74,14.26c-1.29-.61-1.47-1.43-1.47-1.43,1.36,1,2,.5,2,.5.4-.11.47-1.47.47-1.47a3,3,0,0,1,.64,1c.43,1.54,2.76,3.51,2.76,3.51C26.35,58.51,30,63.2,30,63.2l2.37,3.4a2.55,2.55,0,0,0,1-.54c1-.68,4.51-5.19,4.51-5.19-1.36-2.11-5.33-7.09-5.33-7.09a22.67,22.67,0,0,0-.9-5.69,47,47,0,0,1,.07-8.27c2.19,4.3,4.84,4.58,4.84,4.58,1.71.43,6.83-4.51,6.83-4.51,3.23-2.54,3.55-5,3.55-5a9.4,9.4,0,0,0-.08-3.78c0-.09,0-.17,0-.25,1.77,2,1,5.28,1,5.28-.46,4.91-4.72,12.92-4.72,12.92C41.56,52.39,39,59,39,59c-1,2.11-.29,2.33-.29,2.33a4.87,4.87,0,0,0,1,1.36l.09.11a1.34,1.34,0,0,1-.09,1.79l-6.8,7.91c-1.36,1.43-2,.64-2,.64l-2-2.29L30.39,70l.22-4.61c-3.12-5.16-8.88-10.21-8.88-10.21A5.08,5.08,0,0,0,20.62,55.18Z" />
								</svg>
								<p className="text">中途</p>
								<p className="number percent">
									<span className="count">
										{options.midCareer}
									</span>
									%
								</p>
							</div>
							<div className="new">
								<svg
									className="svgIllust"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 64.53 111.76"
								>
									<title />
									<path d="M14.72,20.43S13.53,11.74,16,7.07l.34.33a14.89,14.89,0,0,1,3.62-4.15l1.39-1.53.71.43A3.27,3.27,0,0,1,23.12,0s-.28,1.34,1.53,1.72a.88.88,0,0,1,1-.62s6.35.9,8.55,4c0,0,4.63,4.82,4.34,13.94,0,0,2.34.05,2,3.1,0,0-1.29,6.87-3.15,6.4a7.76,7.76,0,0,1-1.58,5,6.24,6.24,0,0,1-.24,5.16s-2.86,7.06-6.3,10.78c0,0-1.58.53-5.73-6.11,0,0-2.86-3.86-3.1-7A29.48,29.48,0,0,1,16.58,29s-1.72.43-1.53-3.05C15.05,26,12.76,21.86,14.72,20.43Z" />
									<path d="M36.24,35.75s.53,0,2.64,1.49l17.8,5.29s2.72.53,3.06,4.06c0,0,1.33,5.25,1,8.45,0,0,2.86,15.74,3.58,22.14a7.86,7.86,0,0,1-1,6s1.09,1.57-2.58,5.25c0,0-3.15,7-4.68,8.49,0,0-6.06,7-6.83,5,0,0,4.49-2.48.72-9.21,0,0-3.44-5.11-7.49-3.54,0,0-1,1.72-4.35,2.06,0,0-2.91,2.67-5.78,2.19l-3.48,0s-1.19-.33-1.19,1.29-.29,4.25-.24,7.07a2.21,2.21,0,0,1-2.72-1.86s.14-.91-1.48-2.06a3.52,3.52,0,0,0-.62-3.53,25.23,25.23,0,0,1-3.44-3.58,19.5,19.5,0,0,1-2.44.19s-3.1,0-4.24,5.25c0,0-.62,2.77-1.91,3.34,0,0-1,.43-3.77-5.25l-6-11.79S-.56,80.25.26,70.65L1.93,50.51S1.54,47.74,5.55,46l9.31-4.25a23.88,23.88,0,0,0,5.3-3.67s.43-.62.24,3.86A45.13,45.13,0,0,0,21.55,52.8s6.39,32,8.68,34.51c0,0,.53-.14,1-2.34C31.19,85,40.25,38.71,36.24,35.75Z" />
									<path d="M26.5,50s3.59.09,5.54,0c0,0,1.81-.18,1,1.54,0,0-1.13,2.18-.77,2.91a15.06,15.06,0,0,1,1,3.08,30.13,30.13,0,0,1,0,12.7s-2.05,15.47-3,16.24a104.28,104.28,0,0,1-3.39-11.2A10.68,10.68,0,0,0,27.25,72a37.26,37.26,0,0,1-.52-5.17,23.62,23.62,0,0,1,.82-5.67l.81-5s.5-1-.68-2.54a6.88,6.88,0,0,0-2-2.08S25.32,50.27,26.5,50Z" />
									<path d="M46.81,98.14c.56-2.28-.23-4-1.09-5.92a.54.54,0,0,0-.07-.13A2.45,2.45,0,0,0,43,90.76c-1.62.57-1.78.47-1.78.47-3.78.69-4.67,2.81-4.67,2.81s-5.59-.13-7.15-.2-1.35.53-1.35.53l-.27,7.78-3.54-.07a2.32,2.32,0,0,0-.73-1.82c-.23-1.62-1.22-1.62-1.22-1.62a11.6,11.6,0,0,0-.56-3.74c-1.6-2.67-3.18-2.58-3.18-2.58a3.34,3.34,0,0,0-2.35.83A14.64,14.64,0,0,1,14.61,95a19.72,19.72,0,0,0-3.17,4.83c-.63,1.1-.47,1.63-.47,1.63.47.59.17,2.91.17,2.91a4.11,4.11,0,0,0,1.39,1.52,1.46,1.46,0,0,0,1.13,1.32c1.25.5,4.63,3.81,4.63,3.81,1,.89,1.26.69,1.26.69,2.18-.33,2.38-2.81,2.38-2.81l11.81.3c1.29,1.88,2.18,1.49,2.18,1.49,1.16-.57,7.45-2.65,7.45-2.65,2.12-.56,1.72-2.15,1.72-2.15a1.09,1.09,0,0,0,.5-1.06v-3.41A13,13,0,0,0,46.81,98.14Zm-30.24,2.55,1.12-.2a2.57,2.57,0,0,0,.2,1.36l-1.32-1.06Zm17.36,6.22-.19,1.76-16.51-.47a17.46,17.46,0,0,1,1.65-3.8,1.8,1.8,0,0,0,1.36.39s1.39,0,1.92-2.25l9.76.2s-.46,2,2,1.46c0,0-1.55.63-1.48,1.45C32.45,105.65,32.49,106.68,33.93,106.91Zm.51,1.26.16-1.26h1.49Zm4.5-6.93a12.33,12.33,0,0,1-3.31,2.2s2.45-2.82,2.35-3.81C38,99.63,40.13,100.3,38.94,101.24Z" />
								</svg>
								<p className="text">新卒</p>
								<p className="number percent">
									<span className="count">
										{options.newGrads}
									</span>
									%
								</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_job">
						<div className="title">
							<p>職種比</p>
						</div>
						<div className="item">
							<div className="job_item icon-brackets">
								<p className="text">ディレクター</p>
								<div className="bar bar_director">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.director}
									</span>
									%
								</p>
							</div>
							<div className="job_item icon-brackets">
								<p className="text">デザイナー</p>
								<div className="bar bar_designer">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.designer}
									</span>
									%
								</p>
							</div>
							<div className="job_item icon-brackets">
								<p className="text">エンジニア</p>
								<div className="bar bar_engineer">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.engineer}
									</span>
									%
								</p>
							</div>
							<div className="job_item icon-brackets">
								<p className="text">企画提案営業</p>
								<div className="bar bar_sales">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.sales}
									</span>
									%
								</p>
							</div>
							<div className="job_item icon-brackets">
								<p className="text">経営企画室</p>
								<div className="bar bar_planner">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.accounting}
									</span>
									%
								</p>
							</div>
							<div className="job_item icon-brackets">
								<p className="text">社長秘書</p>
								<div className="bar bar_secretary">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.secretary}
									</span>
									%
								</p>
							</div>
							{/* <div className="job_item icon-brackets">
                <p className="text">動画クリエイター</p>
                <div className="bar bar_video">
                  <div className="bar_inner" />
                </div>
                <p className="number percent">
                  <span className="count">{options.video}</span>%
                </p>
              </div> */}
							<div className="job_item icon-brackets">
								<p className="text">
									サポートデスク・アルバイト
								</p>
								<div className="bar bar_support">
									<div className="bar_inner" />
								</div>
								<p className="number percent">
									<span className="count">
										{options.supportDesk}
									</span>
									%
								</p>
							</div>
							<div className="job_item is-blank"></div>
						</div>
					</div>
					{/* <div className="numbers_item num_clothes">
            <div className="title">
              <p>服装比</p>
            </div>
            <div className="item">
              <div className="clothes_item">
                <div className="step">
                  <svg
                    className="svgIllust"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32.31 102.8"
                  >
                    <title />
                    <path d="M12.21,9.09a9.11,9.11,0,0,0,.54,1.27c.15.29.29.15.29.15a14.07,14.07,0,0,0,.59,2.59,12.53,12.53,0,0,0,1.08,1.81l0,.79a8.28,8.28,0,0,0,2.46,1.48c.5,0,2.4-1.75,3.42-3.07l-.25-1.79s.2-.74.39-.84.2-.39.3-.58.53-.78.83-1.52.44-1.56.05-1.8c0,0,0-1.67.14-2.55a3.3,3.3,0,0,0-1.61-2.68A4.29,4.29,0,0,0,17.64.1c-1.27-.39-2.84.44-3,1.17a2,2,0,0,0-1.52,1.62s-.44-.05-.83.63c-1.07,2,.15,4.4.15,4.4C12.07,7.82,12.07,8.6,12.21,9.09ZM32.07,30.82c.43-.57.14-2.57.14-2.57a11.08,11.08,0,0,1-.85-4.15c0-2.29-.42-3.51-1.29-4.3a1.62,1.62,0,0,0-.6-.36.93.93,0,0,0-.68-.21c-.85-.27-4.14-1.54-4.14-1.54l-.15-.32-2.18-.85-.76-1.21a34.44,34.44,0,0,0-.84,4.51c-.18,2.12-2.91,12.24-2.91,12.24s.09-6.69.09-7.31-.44-4.31-.44-4.93.79-1.14.79-1.14-.61-1.06-1-1.15-1.14.45-1.14.45.18,1.58.18,1.84-.71,9.34-.8,13.21C15,31.14,14.14,20.3,13.91,17.32l0,.05a21.53,21.53,0,0,0-2.7,1.38v.16L7.41,20.82C7.09,21,6.51,21,6.3,22s-.16,1.8-.27,2.06a4,4,0,0,0-.48,1.7,6.45,6.45,0,0,1,.32,2.5,10,10,0,0,0-1,3.07c0,1.06.48,2.07.21,2.76a8.57,8.57,0,0,0-.27,2.5c0,.47-.53,3.76-.47,4.24s-.43,2.71.05,3.71,0,3.35,0,3.77.58,3.77,1,4.14a1.27,1.27,0,0,0,.9.32s1,7.53,1.06,8.91.69,10,.9,10.41a5.79,5.79,0,0,1,.11,2.12c-.05.48-.43,6-.53,6.53s-.21,4.35-.21,4.35.32,3.82.26,4.19-.63,1.27-.42,1.65S5.24,96.33,4.6,96.49A32,32,0,0,0,.25,98.87c-.58.43-.06,1.33.69,1.65s4.61.26,5.41-.27,1.8-1.75,2.39-2,.53.32.79.37,2-.16,2.29-.69a10,10,0,0,0,.26-2.81l.37-.53s0-3.5-.16-3.77,1.38-3.23,1.22-3.92-.1-1.81-.16-2,1.28-7.58,1.22-8.22.48-5.52.43-5.68.63-6.17.74-6.59,1.22-6.21,1.43-6.79,2.23,8.93,2.23,9.88a81.36,81.36,0,0,0,1.33,8.91,10.77,10.77,0,0,1,.69,2.23c0,.37-.43,1.43-.37,1.75s.53,4.51.85,4.77.47,1.07.69,1.6.69,2.65.69,2.65-.48,2.44-.59,2.81-.32,2.76.11,3,.26,2.13.48,2.65,1,1.23,1,1.44a3,3,0,0,0,.69,2.07c.75.79,2.76,1.91,4,1.22s.26-3.45-.43-4.46-.64-3.13-.8-3.29.48-3,.27-3.45-.32-1.43-.48-1.59a21.29,21.29,0,0,1-.05-3.23c0-.38-.85-11.62-.9-12s.05-6.31.16-7S27,63.1,27,62.94s.1-1.18.22-2.62a.71.71,0,0,0,.14-.1l.69.47a1.86,1.86,0,0,0,1.06.06.7.7,0,0,0,.32-.27,2,2,0,0,0,.58-.27,3.2,3.2,0,0,1,.4-.45c.05,0,.69-.39.74-.73s-.06-2.88-.06-2.88.43,0,.46-.13a3.73,3.73,0,0,0,0-.54.45.45,0,0,0,.24-.28c.14-.43.36-15.94.36-16.51V34.54C32.21,34.11,31.64,31.39,32.07,30.82ZM9.8,35.14v.36l-.26.7s0-2.64.26-2.38S9.8,34.79,9.8,35.14ZM27.67,47.55c-.23-1.27-.46-2.39-.52-2.59-.16-.48-.69-4.25-.8-4.56a41.86,41.86,0,0,1-.21-5.26c.11-.58.37-1.43.37-1.43s.09-.31.23-.82l.18,2.94V38.4l-.14,2.29,1,6Z" />
                  </svg>
                  <div className="step_top" />
                  <div className="step_center">
                    <div className="step_center_l" />
                    <div className="step_center_r" />
                  </div>
                  <div className="step_bottom" />
                </div>
                <p className="number percent">
                  <span className="count">{options.businessClothes}</span>%
                </p>
                <p className="text">ビジネススーツ</p>
              </div>
              <div className="clothes_item">
                <div className="step">
                  <svg
                    className="svgIllust"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40.61 176.97"
                  >
                    <title />
                    <path d="M3.76,97.07l1.79,1.28s-1.36,23.13-1.88,26.47S.16,145,2,157.84a4.5,4.5,0,0,0,1,3.08l.25,2.56s-3.08,2.31-1.54,4.88-.77,5.13,3.08,7.18,11.81,2.06,9.75-1a47.91,47.91,0,0,1-3.84-7.69l-.26-8a2.2,2.2,0,0,0,1.28-2.05c0-1.54,3.25-27.11,3.25-27.11l5.73-29.81s-2.56,27.67-2.56,29.46-1,23.36-.52,27.72a3.86,3.86,0,0,1,.77,2.82s-1.28,4.36-.77,6.93l.52,3.33H24s8.47,2.57,13.6,1.54,2.31-3.59,1.28-3.85-10-3.33-11-5.38a14.82,14.82,0,0,1-1.29-4.37l1.29-.77s2.05-24.79,2.05-28c0-6.21,3.93-20.61,6.26-31.71.76-.52.94-1.9,1.44-3.39a42,42,0,0,0,1.28-5.65l.26-3.85,1-.77s0-16-.76-20.06c-1.8-9.75,1-28.74-3.86-30.53a31.82,31.82,0,0,1-4.71-2.76c-1.27-1.24-2.47-2.38-2.47-2.38a5.77,5.77,0,0,0-2.54-3.62c0-.37,0-.61,0-.61s.9-.13.9-.64a46.48,46.48,0,0,1,1.8-6.16c.64-1.67.25-3.59.25-4.75s.39-2.05.39-2.69A8.38,8.38,0,0,0,28.66,8a9.79,9.79,0,0,0,.24-3.52c0-2-2.18-4.24-4.74-4.49S21.72,1.31,18.38,2s-6.28,3.6-6,5.65a34.51,34.51,0,0,0,1.29,5.13,11.17,11.17,0,0,1,0,2.18c-.13,1.16,1.54,3.34,1.54,3.34a6.69,6.69,0,0,1,1.41,3.2,7.41,7.41,0,0,1-.05,1.19,1.51,1.51,0,0,0-.72.48,22.85,22.85,0,0,0-2.06,3.59,35.07,35.07,0,0,1-9.49,4.11C3.5,30.82.68,32.1.68,33.9S.93,65.46.42,68-.35,84.5.93,86s.52,7.18,1.29,8.46Zm13.86-67s-2-2.92-.52-2.05c5.39,3.16,9.75.85,9.75.85l1,1.71a33.24,33.24,0,0,1,1.8,4.37c.51,1.79.25,24.63.51,25.91S30.7,76,31.47,81.11c-5.9,1.54-14.37-.51-14.37-.51S22,60.33,23,58.28,19.41,32.62,17.62,30.05Z" />
                  </svg>
                  <div className="step_top" />
                  <div className="step_center">
                    <div className="step_center_l" />
                    <div className="step_center_r" />
                  </div>
                  <div className="step_bottom" />
                </div>
                <p className="number percent">
                  <span className="count">{options.officeCasual}</span>%
                </p>
                <p className="text">オフィスカジュアル</p>
              </div>
              <div className="clothes_item">
                <div className="step">
                  <svg
                    className="svgIllust"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 23.78 82.83"
                  >
                    <title />
                    <path d="M.11,43.52C.16,43.7.28,45,.28,45l.3.31a2.66,2.66,0,0,0,.53.5c.06,0,.24.18.4.18a.28.28,0,0,0,.24-.12H2c.06,0,.16,0,.06-.24a.78.78,0,0,0-.63-.32c-.15,0-.3-.42-.21-.27s.45.12.63.18.54-.21.42-.3-.39-.36-.39-.54a9.65,9.65,0,0,1,.33-2.23c.27-.87-.36-2.53-.48-3.16a17,17,0,0,1,1-4.88c.57-1.66,1-3.85,1-3.85l.43-.09s0-.36,0-.52A1.51,1.51,0,0,1,4.42,29c.12-.12,0-.27,0-.45a.75.75,0,0,1,.15-.72c.21-.24-.06-.51.06-.88s.18-1.23.33-.69a1.85,1.85,0,0,1,0,1.33,3.58,3.58,0,0,0-.09,1.32l-.33,1a3.21,3.21,0,0,0-.06.9A1.66,1.66,0,0,1,4.54,32a4.49,4.49,0,0,0-.42,1.66c-.18,1.2-.09,1.93-.21,2.68s-.46,2.23-.46,2.23l.42.33s-.39,1.44-.54,1.74.52.67.67.82,0,.12,0,.69a1.43,1.43,0,0,0,.22.93,6,6,0,0,1-.24.75c-.13.28,0,.28.09.64s.12.81-.07,1,0,.39.07.9.27,3.8.27,3.8a3.56,3.56,0,0,1-.15.75c-.09.18.3.33.27.6s.15,2,.12,2.41a5.84,5.84,0,0,1-.12,1.47,1,1,0,0,0,.21,1c.24.33,0,1.14,0,1.41s0,.31-.12.46.06.75.21.93.21.27,0,.57.3.63.21.93.27.67.27.67a5.07,5.07,0,0,0,.39,1.35,16.23,16.23,0,0,1,.78,2.32,4.86,4.86,0,0,1,.45,1.41c0,.52.43,1.06.43,1.48s1,1.65,1,1.84.12.39.33.72.27.42.27.51.06.21-.18.27-.15.87-.24,1.45A12.63,12.63,0,0,1,7,75.87a3.25,3.25,0,0,0-.49,1.53,1.12,1.12,0,0,0,.85,1.51c1.77.36,3.13-1,3.82-2.2s.66-2.83.84-3.64,1.18-1.48,1.36-2.65a2.16,2.16,0,0,0-.91-1.93,2.71,2.71,0,0,1-.3-.51,3.3,3.3,0,0,1,.06-1.18c.13-.33-.15-.42-.3-.57a1.11,1.11,0,0,1-.3-.84,5.2,5.2,0,0,1,0-1c0-.42-.27-.64-.36-.82a1.07,1.07,0,0,0-.12-.21,3.85,3.85,0,0,1-.3-.87,6.76,6.76,0,0,0-.27-1.2c-.12-.37-.21-.94-.06-1.12s-.09-.9-.15-1.08a1.47,1.47,0,0,1,0-.81c.09-.31-.06-.4-.09-.58a1.31,1.31,0,0,1,.45-.81c.27-.27-.27-.48-.24-.87s0-1,.06-1.18-.24-.51-.27-.84a6.17,6.17,0,0,1,.39-1.63c.21-.69.18-1.38.33-1.74a16.87,16.87,0,0,0,.93-2.23,9.87,9.87,0,0,1,.31,1.42,8.93,8.93,0,0,0,.42,1.08c.15.39.21,1.32.51,2.26a4.79,4.79,0,0,1,.27,2.1c-.09.19-.15.25-.06.76a4.78,4.78,0,0,1,0,1.59c-.09.27,0,.64-.24.82s.15.72.54,1.2.12.63-.06,1.11.57.61.72.79,0,.33-.15.81.27.36.39.45-.09.54-.33,1.08.33,1.06.27,1.15,0,2.83-.06,3.16a5.1,5.1,0,0,0,.21,1.17c.09.49.4,1.12.09,1.48a2.78,2.78,0,0,0-.57,1.23c.06.09-.09.33-.24.58s.54.93.6,1a.94.94,0,0,1-.09.63,1.9,1.9,0,0,0-.36.75c-.09.37,0,.49.15.79s-.24.6-.39.84.06.75.21,1.17.15.24.06.79,0,.36,0,.57A7.27,7.27,0,0,1,14,80.62a7.2,7.2,0,0,0-.09,1,.79.79,0,0,0,.12.84c.33.51,3.07.45,4,.27s.93-.72.87-1.5a3.35,3.35,0,0,0-.57-1.78,1.53,1.53,0,0,1-.3-1.17,2.72,2.72,0,0,1,.48-1,.66.66,0,0,0,.18-.54c0-.21-.24-.66-.15-.93s.24-.24.36-.3-.09-.58-.09-.58.09-.45.33-.51.21-.75.27-1.23-.12-.36-.42-.63-.24-.34,0-.64.33-.27.45-.54A9.58,9.58,0,0,0,19.5,69c0-1.17-.06-6.32.09-6.68s.12-.21-.06-.54a1.56,1.56,0,0,1-.27-.94c0-.45-.33-.78-.36-1a1.2,1.2,0,0,1,.3-.69.35.35,0,0,0,0-.54A4.46,4.46,0,0,1,19,56.84a27.85,27.85,0,0,1,.09-3.76c.18-1,.57-4.16.6-4.55a1.91,1.91,0,0,1,.24-1.14c.3-.52-.09-1,0-1.33a4.54,4.54,0,0,1,.21-1.38c.21-.39-.33-1.21-.36-1.42a3.21,3.21,0,0,1,0-.81c0-.39-.24-.6-.24-.9s-.27-1.46-.21-1.42.59-.13.59-.13-.23-.71-.26-.82a.44.44,0,0,1,.05-.42c.12-.13-.05-.34-.25-.66a.78.78,0,0,1,0-.78c.09-.3-.18-.52-.3-.79s-.35-.84-.45-1.16.19-.61.34-.84,0-.54-.16-.93a2.59,2.59,0,0,1-.24-1.33,5,5,0,0,0,.15-1,2.37,2.37,0,0,0-.18-.82c-.12-.27.1-.58.21-.8s-.09-.64-.12-.91a1.59,1.59,0,0,1,0-.67,7.59,7.59,0,0,0,.06-.87,6.48,6.48,0,0,1,0-.8c.06-.15.14.18.23.38s-.05.48-.08.66a.67.67,0,0,0,.15.5c.09.09.12.24,0,.56-.23.24-.06.61-.08.72a3.54,3.54,0,0,1-.18.78c-.09.18.06.53.06.66s.27.29.27.29.37.19.37.29.3,1.27.52,2.3,1.1,4.32,1.18,4.92a8.57,8.57,0,0,1-.12,2,6.68,6.68,0,0,0-.47,1.4,1.66,1.66,0,0,0,.24,1.28,2.92,2.92,0,0,1,.06,1.07,5,5,0,0,0,.08.72c0,.14-.05.55.19.56s.51-.26.56-.69a2.6,2.6,0,0,0-.08-.85c0-.13,0-.49,0-.55l.21-.15a2.49,2.49,0,0,1,.34.22c.15.12.19.5.28.83-.19.14-.12,1-.12,1a1.63,1.63,0,0,1-.68.18c-.28,0-.18.17-.3.23-.48.07-.48.3-.51.34s.09.21.14.21,0,.09,0,.09-.11.18-.05.3.66-.09.81-.09a4.88,4.88,0,0,0,.9-.48,1.88,1.88,0,0,0,.57-.18c.3-.15.3-1.35.34-1.53a3.45,3.45,0,0,1,.15-.67,1.28,1.28,0,0,0,0-.45,3.74,3.74,0,0,1-.28-.78A10.92,10.92,0,0,1,23,39.86c0-.87-.09-2.38.06-3.67a18.21,18.21,0,0,0,0-3.83c-.12-.63-.21-2-.21-2,.3-.12.18-.33.18-.45s0-.7,0-.7a.88.88,0,0,1,.18-.3c.12-.12-.27-.21-.42-.42a2.35,2.35,0,0,1-.12-1.35c.12-.18-.06-.25-.09-.4s-.12-.57,0-.78,0-.42,0-.57a1.62,1.62,0,0,1,.18-.54c.09-.21-.24-.42-.3-.76s-.24-2.28-.24-2.61-.09-1.18-.12-1.78a23.57,23.57,0,0,0-.6-3c-.09-.24-.79-.78-.82-.93s-.33-.09-.42-.09-.21-.16-.57-.37S16.1,13.79,16,13.67a.7.7,0,0,1-.24-.39c0-.12-.21-.24-.36-.45s-.55,0-.55,0l-.24-.16s-.18-1.59-.18-1.68a2,2,0,0,1,.12-1.42.36.36,0,0,0,0-.09.92.92,0,0,1,.05.35,3.53,3.53,0,0,0,0-.43l.06-.18c0,.06.07.12.11.17a.92.92,0,0,1-.05.35,1.49,1.49,0,0,0,.08-.31.44.44,0,0,0,.25.15.91.91,0,0,1-.22-.27,2.53,2.53,0,0,0,0-.78,6.59,6.59,0,0,0,.1-.75s.28-.06.36-.21a2.52,2.52,0,0,0,.46-.85c0-.3-.06-.72-.15-.75s-.22-.33-.22-.33.1-1.09.16-1.43a1.93,1.93,0,0,0,0-.26A3.67,3.67,0,0,1,15.77,5a4,4,0,0,0-.24-1.39c0-.3-.06-.58-.06-.58l.42.12a2.93,2.93,0,0,1-.54-.75,3,3,0,0,0-.16-.3,3.72,3.72,0,0,1,.7.66,4.39,4.39,0,0,0-.84-.87,4.83,4.83,0,0,0-.31-.42l.46-.31a1.63,1.63,0,0,1-1-.24C14,.83,13.84.74,13.63.66A6.72,6.72,0,0,0,14.44,0a4,4,0,0,1-1.12.54,3.47,3.47,0,0,0-2-.24c-.63.27-.51.54-.78.45s-.28-.13-.77.12A1.62,1.62,0,0,0,7.87,2.2C7,3.11,7.65,3.79,7.7,4.12s0,.88.09,1.57.21.69.21.69a3.52,3.52,0,0,1-.12.48A4,4,0,0,0,8.3,8.19c.12.18.51.24.51.24a1,1,0,0,0,0,.16A.54.54,0,0,1,8.52,9a.83.83,0,0,0,.35-.25.13.13,0,0,0,0,.06,1.92,1.92,0,0,0,.06,1.24,2,2,0,0,1,0-1,9.23,9.23,0,0,0,.54,1.17c0,.47.09,1.93.06,2s-.17,0-.25,0-.19,0-.24.18-.51.5-.51.5a.19.19,0,0,0-.13-.16c-.12,0-.46.33-.73.54a2.48,2.48,0,0,1-1.23.22,6,6,0,0,0-1.42.55A15.63,15.63,0,0,0,2.9,15.43c-.29.23-.37.1-.3.48-.71.47-.53,1.85-.59,2.29s-.14,1.79-.2,2a2.51,2.51,0,0,1-.28.87c-.2.29,0,1.46,0,1.46s0,.34-.12.46,0,.4.05.63a1,1,0,0,1-.14.6,3.43,3.43,0,0,0-.19,1.11c0,.19.09.41.09.53s-.06.15-.2.3.06.32.06.32,0,.13-.19.19-.15.12-.17.19,0,.73,0,.94,0,.23-.18.35,0,.36-.08.54a4.16,4.16,0,0,0-.1.63,2,2,0,0,1,.3.15,17.79,17.79,0,0,0-.26,5,34.86,34.86,0,0,1-.19,4,1.8,1.8,0,0,0,.09.71A12.57,12.57,0,0,1,.26,41c0,.27-.22,1.81-.25,1.93A2.08,2.08,0,0,0,.11,43.52ZM9.57,1c-.27.15-.61.37-1.09.7A4.06,4.06,0,0,0,8,2.06,2,2,0,0,1,9.57,1Zm5.12,8,0-.09c0,.07,0,.14,0,.2A1.17,1.17,0,0,1,14.69,9ZM.79,43.19a5.22,5.22,0,0,0,.29-.72l.24.68-.12,1L1,43.83S.67,43.39.79,43.19Z" />
                  </svg>
                  <div className="step_top" />
                  <div className="step_center">
                    <div className="step_center_l" />
                    <div className="step_center_r" />
                  </div>
                  <div className="step_bottom" />
                </div>
                <p className="number percent">
                  <span className="count">{options.casualClothes}</span>%
                </p>
                <p className="text">カジュアル</p>
              </div>
            </div>
          </div> */}
					{/* <div className="numbers_item num_salaried">
            <div className="title">
              <p>有給消化率</p>
            </div>
            <div className="item">
              <svg id="dayOffPctg" width="220" height="220" />
              <p className="number percent">
                <span className="count">{options.dayOffPercentage}</span>%
              </p>
            </div>
          </div> */}
					<div className="numbers_item num_numberOnly num_holiday">
						<div className="title">
							<p>年間休日数</p>
						</div>
						<div className="image">
							<svg
								className="svgIcon"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 88.59 94.8"
							>
								<path d="M84.87,6.2H71.62V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H47.77V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H23.91V3a3,3,0,0,0-3-3h-1a3,3,0,0,0-3,3V6.2H3.69A3.71,3.71,0,0,0,0,9.92V91.07A3.72,3.72,0,0,0,3.69,94.8H84.87a3.72,3.72,0,0,0,3.72-3.73V9.92A3.71,3.71,0,0,0,84.87,6.2ZM23.93,14a6.84,6.84,0,0,1,1.12,1,7,7,0,0,1,1.24,1.85,6.72,6.72,0,0,1,.5,2.5,6.36,6.36,0,0,1-12.72,0,6.52,6.52,0,0,1,.5-2.5,6.74,6.74,0,0,1,1.24-1.85,6.63,6.63,0,0,1,1.13-1v4.46a3.49,3.49,0,1,0,7,0V14.27Zm23.85,0a6.45,6.45,0,0,1,1.12,1,6.74,6.74,0,0,1,1.24,1.85,6.52,6.52,0,0,1,.5,2.5,6.36,6.36,0,1,1-12.72,0,6.18,6.18,0,0,1,1.75-4.35,5.74,5.74,0,0,1,1.16-1v4.46a3.47,3.47,0,1,0,6.94,0V14Zm23.86,0a6.45,6.45,0,0,1,1.12,1A7,7,0,0,1,74,16.76a6.52,6.52,0,0,1,.5,2.5,6.36,6.36,0,1,1-12.72,0,6.72,6.72,0,0,1,.5-2.5,7,7,0,0,1,1.24-1.85,6.35,6.35,0,0,1,1.16-1v4.46a3.47,3.47,0,1,0,6.94,0V14.27ZM78,84.24H10.56V31.09H78Z"></path>
								<rect
									x="21.11"
									y="40.13"
									width="7.92"
									height="7.92"
								></rect>
								<polygon points="41.84 40.19 41.84 40.16 41.84 40.16 41.84 40.13 33.92 40.13 33.92 48.05 41.84 48.05 41.84 40.19"></polygon>
								<polygon points="46.74 48.02 46.74 48.05 54.65 48.05 54.65 40.13 46.74 40.13 46.74 48 46.74 48.02 46.74 48.02"></polygon>
								<polygon points="59.55 48.02 59.55 48.05 67.47 48.05 67.47 40.13 59.55 40.13 59.55 48 59.55 48.02 59.55 48.02"></polygon>
								<rect
									x="21.11"
									y="52.95"
									width="7.92"
									height="7.92"
								></rect>
								<polygon points="41.84 53.01 41.84 52.98 41.84 52.98 41.84 52.95 33.92 52.95 33.92 60.87 41.84 60.87 41.84 53.01"></polygon>
								<polygon points="46.74 60.87 54.65 60.87 54.65 52.95 46.74 52.95 46.74 60.82 46.74 60.84 46.74 60.84 46.74 60.87"></polygon>
								<polygon points="59.55 60.87 67.47 60.87 67.47 52.95 59.55 52.95 59.55 60.82 59.55 60.84 59.55 60.84 59.55 60.87"></polygon>
								<polygon points="29.02 65.77 21.16 65.77 21.14 65.77 21.14 65.77 21.11 65.77 21.11 73.69 29.02 73.69 29.02 65.77"></polygon>
								<polygon points="41.84 65.82 41.84 65.8 41.84 65.8 41.84 65.77 33.98 65.77 33.95 65.77 33.95 65.77 33.92 65.77 33.92 73.69 41.84 73.69 41.84 65.82"></polygon>
								<polygon points="46.74 73.69 54.65 73.69 54.65 65.77 46.79 65.77 46.77 65.77 46.77 65.77 46.74 65.77 46.74 73.63 46.74 73.66 46.74 73.66 46.74 73.69"></polygon>
								<polygon points="59.55 73.69 67.47 73.69 67.47 65.77 59.61 65.77 59.58 65.77 59.58 65.77 59.55 65.77 59.55 73.63 59.55 73.66 59.55 73.66 59.55 73.69"></polygon>
							</svg>
						</div>
						<div className="item">
							<div className="numberOnly_item">
								<p className="number">
									<span className="count">
										{options.holidayCounter}
									</span>
									日
								</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_numberOnly num_over">
						<div className="title">
							<p>平均残業時間</p>
						</div>
						<div className="image">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 88.6 94.8"
							>
								<g>
									<g>
										<g>
											<path
												d="M44.3,3.1C19.9,3.1,0,23,0,47.4s19.9,44.3,44.3,44.3s44.3-19.9,44.3-44.3S68.7,3.1,44.3,3.1z M62.9,66l-23-14.2V25.3h6.6
                      v23l19.9,12L62.9,66z"
											/>
										</g>
									</g>
								</g>
							</svg>
						</div>
						<div className="item">
							<div className="numberOnly_item">
								<p className="number">
									<span className="count">
										{/* {options.overCounter} */}
										8.5
									</span>
									h/月
								</p>
							</div>
						</div>
					</div>
					{/* <div className="numbers_item num_officer">
            <div className="title">
              <p>最年少役員</p>
            </div>
            <div className="item">
              <svg
                className="svgIllust"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 70.64 77.77"
              >
                <title />
                <path
                  className="svgOfficer01"
                  d="M35.32,11.44l31,31-31,31-31-31,31-31m0-4.31L0,42.45,35.32,77.77,70.64,42.45,35.32,7.13Z"
                />
                <path
                  className="svgOfficer02"
                  d="M33.87,23.56a21.34,21.34,0,0,1,1.94-1.85,15.45,15.45,0,0,0,2.64-4.3l-.17-.32a10.93,10.93,0,0,0,.77-2.21,21.29,21.29,0,0,0,1.44-4.31c.18-1.19.42-4.54-.3-6.1a12.27,12.27,0,0,0-3.71-4C35.7,0,34.09-.08,33.67.34s-2.42-1.16-4,.36a12.56,12.56,0,0,1-2.51,2.07l.72.09a4.37,4.37,0,0,0-1.17,1.43c-.72,1.17-1.44,4-1,5.48a7.22,7.22,0,0,0,1.38,3,3.85,3.85,0,0,1,.78,2.21c-.06.12.3-.36.3-.36a7.31,7.31,0,0,0,.89,2.34c.48.47.77,1.52.49,1.72,1,1.42,3.53,4.8,3.89,5h0l.16.1.21-.19"
                />
                <path
                  className="svgOfficer02"
                  d="M52.93,39.42c-.07-.74.31-2.22.18-3s-.25-4.45-.61-4.82-1.24-2.09-1-2.65a18.14,18.14,0,0,0-.93-5.06,21.75,21.75,0,0,0-4.87-1.66,13.24,13.24,0,0,1-3.76-.8,18,18,0,0,1-2.47-2.41,1,1,0,0,1-.09-.15A18.37,18.37,0,0,1,38,23.47S36.92,29.12,36.55,30s-1.48,7-1.48,7h0a11.92,11.92,0,0,1-1,2.73s-.6-.35-1.49-2.73h0s-2.22-8.7-2.41-10.36-1-6.29-1-6.29-1.66,1.67-2,1.91a49.86,49.86,0,0,1-5.86,2.22,7.8,7.8,0,0,0-2.9,1.24,18.3,18.3,0,0,0-.18,2.65c0,.43-.5,3.88-.5,4.68s-.49,2-.37,2.53-.06,3.64,0,4.07c0,.16.06.64.08,1.21h35.9A4.49,4.49,0,0,1,52.93,39.42Z"
                />
                <polygon
                  className="svgOfficer02"
                  points="32.85 26.62 32.85 26.62 32.85 26.62 32.85 26.62"
                />
                <path
                  className="svgOfficer03"
                  d="M33.66,23.76l.21-.19S35,24.3,35,24.67a7.14,7.14,0,0,1-.15,1.88,12.91,12.91,0,0,0-.11,1.65l.35,8.87a11.92,11.92,0,0,1-1,2.73s-.6-.35-1.49-2.73c0,0,.1-7.52.27-10.45h-.46l-.09-2,1.2-.92Z"
                />
                <rect
                  className="svgOfficer02"
                  x="17.05"
                  y="41.54"
                  width="36.55"
                  height="0.61"
                />
                <rect
                  className="svgOfficer02"
                  x="17.05"
                  y="42.75"
                  width="36.55"
                  height="0.61"
                />
              </svg>
              <p className="number">
                <span className="count">{options.officerCounter}</span>才
              </p>
            </div>
          </div> */}
					<div className="numbers_item num_numberOnly num_remoteWork">
						<div className="title">
							<p>リモートワーク</p>
						</div>
						<div className="image">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 88.6 94.8"
							>
								<path d="M35.4,85.1V58.5h17.7v26.6h22.1V49.6h13.3L44.3,9.7L0,49.6h13.3v35.4H35.4z" />
							</svg>
						</div>
						<div className="item">
							<div className="numberOnly_item">
								<p className="number">
									<span className="count">
										{options.remoteWorkCounter}
									</span>
									日/週
								</p>
								<p className="text">社員の8割</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_numberOnly num_long">
						<div className="title">
							<p>平均勤続年数</p>
						</div>
						<div className="image">
							<svg
								className="svgIcon"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 95.36 94.8"
							>
								<path d="M29.27,26.64A4,4,0,0,0,28.14,30c.21,1.89.78,9.41,4.78,8.07h0c.16,1.12,1.14,6.23,3.63,7.59v10.5h-.21l-.12,0v0h0a29.9,29.9,0,0,0,11.49,9.59,29.62,29.62,0,0,0,10.76-8.61c.29-.36.54-.69.73-1h0l0,0h-.36V45.69c2.77-1.58,3.44-6.16,3.62-7.47a.5.5,0,0,0,0-.12c4,1.33,4.57-6.18,4.77-8.07a4,4,0,0,0-1.12-3.39,6.9,6.9,0,0,0,.43-1.16,23.58,23.58,0,0,0,.84-4.82C67.57,18,67.32,15,66,13.19A18.15,18.15,0,0,0,64.11,11c-1.86-1.85-4.3-3.71-5.72-3.71C56.09,3.1,53.13.4,47.69,0c-.33,0-.68,0-1,0-4.52-.06-12.31,5.35-15.4,11s-4,7.57-2.43,14.53A6.9,6.9,0,0,0,29.27,26.64Z"></path>
								<path d="M93.69,78.11c-.55-2.81-15.5-11.74-25.51-17.3-2.9-1.63-5.43-3-7.12-3.86l0,0L61,57c1.07,1.66,2.38,4.11,2,5.55-.52,2.08-3.91,8.52-7.67,14-.47.67-.94,1.34-1.42,2-.06-.12-2.86-5.2-5.28-9.4l-1-1.71v0c-2.3,3.92-5.47,9.67-6.14,10.89l-.14.23c-4.3-5.82-8.5-13.66-9.09-16-.29-1.19.55-3.06,1.45-4.61.2-.34.4-.65.59-.92l-.05,0,0-.05C27.45,60.46,2.4,74.45,1.67,78.11,1,81.3.25,89,0,91.52a1.2,1.2,0,0,0,.9,1.3c4.49,1.13,23.9,2,47.16,2s42-.85,46.39-2a1.21,1.21,0,0,0,.89-1.3C95.11,89,94.33,81.3,93.69,78.11Z"></path>
							</svg>
						</div>
						<div className="item">
							<div className="numberOnly_item">
								<p className="number">
									<span className="count">4.08</span>年
								</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_sitecore">
						<div className="title">
							<p>Sitecore実績</p>
						</div>
						<div className="item">
							<svg
								className="svgIllust"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 62.47 43.92"
							>
								<path d="M5.75,7.66c-.25,0,0,.14,0,.14,1.88.41,2.39-1.87,2.36-1.94a3.78,3.78,0,0,1-1.37.5c-.92.11-1.42,1.08-1.18,1.13C6.07,7.6,7,7,7,7A2.62,2.62,0,0,1,5.75,7.66ZM6,34.88s.29-.19-.06-.17a3.36,3.36,0,0,1-1.73-.52s1.29.54,1.92.26c.29-.14-.6-1.23-1.8-1.1a4.93,4.93,0,0,1-1.89-.25C2.41,33.2,3.72,36,6,34.88ZM2.87,13.15s.31,0,.08-.14a3.12,3.12,0,0,1-.78-1.43S2.68,12.76,3.25,13c.27.1.37-1.18-.48-1.85a4.52,4.52,0,0,1-1-1.34C1.64,9.83.75,12.41,2.87,13.15ZM11.8,41.68l0,0c1.89-2-.48-4.25-.59-4.27a5.38,5.38,0,0,1-.41,2,2.11,2.11,0,0,0-.19.9c-.42-.53-.83-1.08-1.23-1.66,2.07-1.48.29-4,.2-4a5,5,0,0,1-.74,1.8,2,2,0,0,0-.34.89q-.48-.78-.93-1.62c1.94-1.41.3-3.87.21-3.91A5.12,5.12,0,0,1,7,33.52a1.74,1.74,0,0,0-.28.54c-.32-.68-.63-1.37-.92-2.07h.1C8.2,31.06,7.09,28.31,7,28.26a4.87,4.87,0,0,1-1.07,1.51,1.86,1.86,0,0,0-.58,1c-.28-.75-.54-1.51-.76-2.28C5.21,28.21,5.74,27,5.74,27a3.23,3.23,0,0,1-.86,1.54c-.25.21.09.16.09.16,2.3-.8,1.35-3.6,1.27-3.66a4.86,4.86,0,0,1-1.15,1.45,2,2,0,0,0-.71,1.23C4.15,26.88,4,26,3.79,25.19a3.74,3.74,0,0,0,1.12-1.31A3.28,3.28,0,0,1,4,25.31c-.26.19.06.16.06.16,2.29-.6,1.57-3.38,1.5-3.44a5,5,0,0,1-1.22,1.32,1.81,1.81,0,0,0-.7.9c-.08-.52-.15-1-.21-1.54s-.1-1-.13-1.54a3.68,3.68,0,0,0,1.3-1.09,3.25,3.25,0,0,1-1.14,1.23c-.28.14,0,.16,0,.16,2.31-.21,2.06-3,2-3.08a4.63,4.63,0,0,1-1.39,1.08,1.81,1.81,0,0,0-.85.81c0-.8,0-1.58,0-2.36h0c.62-.06,1.42-1.09,1.42-1.09a3.33,3.33,0,0,1-1.13,1.21c-.28.13,0,.15,0,.15,2.29-.18,2.07-3,2-3a4.6,4.6,0,0,1-1.39,1.06,1.85,1.85,0,0,0-1,1c0-.76.11-1.52.21-2.26h0c2.24.09,2.35-2.64,2.3-2.71a4.54,4.54,0,0,1-1.47.86,1.61,1.61,0,0,0-.66.39c.14-.84.32-1.66.52-2.46l.06,0C6.48,11.57,7.08,8.91,7,8.83a4.49,4.49,0,0,1-1.6.59,1.81,1.81,0,0,0-.85.35A26.23,26.23,0,0,1,6.76,4.61a.09.09,0,0,0,.06.1c.54.13,1.52-.51,1.52-.51A2.71,2.71,0,0,1,7,4.89C6.75,4.92,7,5,7,5c2,.51,2.62-1.9,2.59-2a3.83,3.83,0,0,1-1.48.49,1.61,1.61,0,0,0-1,.51A17.66,17.66,0,0,1,8.5,2l0-.35A2.62,2.62,0,0,1,9.42.79S8.55,1.46,8.5,2c0,.25,1.05.06,1.43-.79A3.9,3.9,0,0,1,10.82,0c-.06,0-2.39-.24-2.55,1.68a.24.24,0,0,0,0,.1c-.28.35-.55.71-.81,1.09a1.69,1.69,0,0,0-.21-1.19A4.29,4.29,0,0,1,6.77.23c-.08,0-1.63,2,0,3.26,0,0,.25.14.11-.1a2.84,2.84,0,0,1-.24-1.46s.08,1.15.51,1.51A21.82,21.82,0,0,0,5.73,5.92a1.59,1.59,0,0,0-.42-1.17,3.73,3.73,0,0,1-.73-1.26c-.07,0-1.13,2.12.58,3,0,0,.26.09.08-.11a2.67,2.67,0,0,1-.49-1.3s.29,1.06.76,1.3h0A27.69,27.69,0,0,0,4.43,9.1,1.87,1.87,0,0,0,4,7.77a4.63,4.63,0,0,1-.82-1.5c-.08,0-1.38,2.43.59,3.52,0,0,.29.1.09-.13a3.2,3.2,0,0,1-.53-1.53s.31,1.23.84,1.54a.09.09,0,0,0,.1,0A31.6,31.6,0,0,0,2.94,16a1.88,1.88,0,0,0-.81-1.12A4.52,4.52,0,0,1,.9,13.63c-.07.06-.65,2.78,1.59,3.27,0,0,.31,0,0-.16a3.16,3.16,0,0,1-1-1.34s.66,1.13,1.27,1.27h0c-.08.93-.12,1.87-.11,2.82a1.94,1.94,0,0,0-1.2-1A4.63,4.63,0,0,1,0,17.64c0,.08.18,2.89,2.5,2.71,0,0,.31-.07,0-.16a3.24,3.24,0,0,1-1.33-1s1,.88,1.58.86c0,.8.06,1.61.14,2.41,0,.25,0,.49.08.74a2,2,0,0,0-1.32-.9A4.93,4.93,0,0,1,0,21.59c0,.09.49,2.9,2.81,2.48,0,0,.31-.11,0-.17A3.17,3.17,0,0,1,1.36,23s1.06.81,1.7.71c.15,1.07.35,2.16.61,3.24a2,2,0,0,0-1.52-1.08A5,5,0,0,1,.4,25.24c0,.09.63,3,3,2.44,0,0,.31-.12,0-.17a3.35,3.35,0,0,1-1.53-.87s1.14.79,1.79.65c.05,0,.07,0,.07-.1.25,1,.54,2,.87,3a2,2,0,0,0-1.49-.79A5,5,0,0,1,1.31,29c0,.1.87,2.92,3.19,2.19,0,0,.31-.15,0-.17a3.31,3.31,0,0,1-1.59-.74s1.2.7,1.84.51l0,0a41,41,0,0,0,2.79,6.35A2.11,2.11,0,0,0,6,36.85a5.23,5.23,0,0,1-1.94.08c0,.1,1.78,2.64,3.88,1.18,0,0,.26-.24-.08-.16A3.44,3.44,0,0,1,6,37.72a3.83,3.83,0,0,0,1.9,0c.46.8.94,1.56,1.44,2.27a2.13,2.13,0,0,0-1.2,0,5.8,5.8,0,0,1-2.07.12c0,.11,1.94,2.78,4.15,1.19l0-.06a17.08,17.08,0,0,0,2.53,2.66l.21-1C12.62,42.5,12.21,42.11,11.8,41.68ZM4.31,10.75a3.87,3.87,0,0,0,1.4-.62,3.07,3.07,0,0,1-1.41.81h0A1.05,1.05,0,0,0,4.31,10.75Zm-.78,3.88a3.83,3.83,0,0,0,1.23-.84,3.05,3.05,0,0,1-1.24,1h0A1.49,1.49,0,0,1,3.53,14.63Zm2.18,17a4.1,4.1,0,0,0,.91-1.44,3.41,3.41,0,0,1-.77,1.59l0,.05Zm1.76,3.78-.1-.19a4.6,4.6,0,0,0,.45-1.42A3.64,3.64,0,0,1,7.47,35.46Zm1.82,3-.11-.17a4.58,4.58,0,0,0,.49-1.59A3.65,3.65,0,0,1,9.29,38.49Zm.86,2.63a3.69,3.69,0,0,1-2-.21,4.92,4.92,0,0,0,1.83,0l.16.21Zm1.35.22a5.19,5.19,0,0,0,.22-1.75,3.78,3.78,0,0,1-.05,1.94Z" />
								<path d="M56.94,7.53c.24,0-.26-1-1.18-1.14a3.78,3.78,0,0,1-1.37-.5c0,.07.47,2.35,2.35,1.94,0,0,.25-.1,0-.14A2.64,2.64,0,0,1,55.53,7S56.42,7.63,56.94,7.53Zm1.2,25.85c-1.21-.12-2.1,1-1.8,1.1.62.28,1.91-.26,1.91-.26a3.46,3.46,0,0,1-1.73.53c-.34,0-.05.17-.05.17C58.73,36,60.05,33.24,60,33.14A4.83,4.83,0,0,1,58.14,33.38Zm2.17-7.47A2,2,0,0,0,58.8,27c.25-1.09.46-2.17.61-3.25.64.11,1.7-.7,1.7-.7a3.24,3.24,0,0,1-1.45.9c-.31.06,0,.17,0,.17,2.32.42,2.85-2.39,2.81-2.48a4.7,4.7,0,0,1-1.67.68,2,2,0,0,0-1.32.89c0-.24.06-.49.08-.73.08-.81.12-1.61.14-2.41.63,0,1.58-.86,1.58-.86a3.26,3.26,0,0,1-1.32,1c-.31.09,0,.17,0,.17,2.31.18,2.54-2.63,2.49-2.71a4.63,4.63,0,0,1-1.56.83,1.92,1.92,0,0,0-1.19,1c0-.95,0-1.89-.11-2.82,0,0,0,0,0,0,.61-.14,1.27-1.26,1.27-1.26a3.1,3.1,0,0,1-1,1.34c-.26.17.06.16.06.16,2.24-.49,1.66-3.21,1.59-3.27a4.52,4.52,0,0,1-1.23,1.23A1.85,1.85,0,0,0,59.53,16a32.42,32.42,0,0,0-1.29-6.33.06.06,0,0,0,.09,0c.54-.3.84-1.54.84-1.54a3,3,0,0,1-.53,1.53c-.2.24.1.13.1.13,2-1.08.66-3.47.59-3.51A4.58,4.58,0,0,1,58.5,7.8a1.83,1.83,0,0,0-.44,1.34A26.74,26.74,0,0,0,57,6.41h0c.47-.25.76-1.3.76-1.3a2.56,2.56,0,0,1-.5,1.29c-.17.2.08.12.08.12,1.72-.88.67-3,.6-3a3.92,3.92,0,0,1-.74,1.25A1.6,1.6,0,0,0,56.76,6a23.43,23.43,0,0,0-1.38-2.48c.42-.36.5-1.51.5-1.51a2.82,2.82,0,0,1-.23,1.46c-.15.24.1.1.1.1,1.6-1.28.06-3.23,0-3.26a4.2,4.2,0,0,1-.51,1.48A1.7,1.7,0,0,0,55,2.93c-.26-.38-.53-.74-.8-1.08,0,0,0-.11,0-.11C54.07-.18,51.74,0,51.68.06a3.73,3.73,0,0,1,.89,1.16C53,2.07,54,2.26,54,2c0-.52-.92-1.19-.92-1.19a2.71,2.71,0,0,1,1,.84L54,2a20.48,20.48,0,0,1,1.42,2.08,1.67,1.67,0,0,0-1.05-.51,4.15,4.15,0,0,1-1.48-.49c0,.08.6,2.49,2.59,2,0,0,.26-.11,0-.15a2.71,2.71,0,0,1-1.31-.69s1,.64,1.52.51c0,0,.06,0,.06-.1a26.05,26.05,0,0,1,2.16,5.17,1.74,1.74,0,0,0-.84-.36,4.5,4.5,0,0,1-1.61-.59c0,.09.56,2.75,2.75,2.27l.06,0c.21.8.38,1.63.53,2.47a1.65,1.65,0,0,0-.67-.39,4.59,4.59,0,0,1-1.47-.87c0,.07.06,2.8,2.3,2.72L59,15c.09.75.16,1.51.21,2.27a1.92,1.92,0,0,0-1-1,4.71,4.71,0,0,1-1.38-1.05c-.06.07-.28,2.84,2,3,0,0,.32,0,0-.16a3,3,0,0,1-1.13-1.21s.79,1,1.42,1.09h0c0,.78,0,1.56,0,2.35a1.86,1.86,0,0,0-.85-.81A4.62,4.62,0,0,1,57,18.42c-.06.07-.31,2.88,2,3.09,0,0,.32,0,0-.16a3.21,3.21,0,0,1-1.13-1.23,3.52,3.52,0,0,0,1.29,1.08c0,.52-.08,1-.13,1.55s-.13,1-.21,1.53a2,2,0,0,0-.7-.9,4.66,4.66,0,0,1-1.22-1.32c-.07.06-.79,2.84,1.49,3.44,0,0,.33,0,.07-.15a3.19,3.19,0,0,1-.93-1.43,3.63,3.63,0,0,0,1.12,1.31q-.26,1.26-.6,2.52a2,2,0,0,0-.7-1.23,5.18,5.18,0,0,1-1.16-1.45c-.07.05-1,2.85,1.27,3.65,0,0,.34.06.08-.15A3.35,3.35,0,0,1,56.73,27s.53,1.22,1.14,1.48c-.24.77-.49,1.53-.77,2.28a1.9,1.9,0,0,0-.58-1,4.74,4.74,0,0,1-1.07-1.51c-.08.06-1.19,2.8,1.07,3.72h.1q-.43,1.06-.93,2.07a1.82,1.82,0,0,0-.27-.54,5.12,5.12,0,0,1-.76-1.75c-.09,0-1.74,2.49.2,3.91-.3.56-.61,1.09-.93,1.62a2,2,0,0,0-.34-.89,5.27,5.27,0,0,1-.74-1.8c-.09,0-1.87,2.56.2,4-.4.59-.82,1.14-1.23,1.66a2.28,2.28,0,0,0-.19-.9,5.35,5.35,0,0,1-.41-2c-.11,0-2.48,2.32-.6,4.28h0c-.41.43-.82.83-1.23,1.19l.21,1a18,18,0,0,0,2.54-2.65l0,0c2.21,1.6,4.15-1.07,4.16-1.18A5.52,5.52,0,0,1,54.29,40a2.13,2.13,0,0,0-1.2,0c.49-.71,1-1.47,1.43-2.27a3.87,3.87,0,0,0,1.91,0A3.44,3.44,0,0,1,54.6,38c-.34-.08-.08.17-.08.17,2.1,1.46,3.88-1.08,3.88-1.19a5.24,5.24,0,0,1-1.94-.08,2.11,2.11,0,0,0-1.56.21,41.07,41.07,0,0,0,2.8-6.35s0,0,0,0c.64.19,1.84-.5,1.84-.5A3.29,3.29,0,0,1,58,31c-.33,0,0,.18,0,.18,2.33.72,3.22-2.09,3.19-2.19a4.76,4.76,0,0,1-1.78.49,2,2,0,0,0-1.5.78c.34-1,.63-2,.88-3a.09.09,0,0,0,.07.1c.65.14,1.79-.65,1.79-.65a3.33,3.33,0,0,1-1.53.86c-.33.05,0,.18,0,.18,2.38.54,3.05-2.35,3-2.44A4.87,4.87,0,0,1,60.31,25.91ZM58.18,11a3.12,3.12,0,0,1-1.41-.81,3.87,3.87,0,0,0,1.4.62,1.46,1.46,0,0,1,0,.2Zm.78,3.9a3.07,3.07,0,0,1-1.24-1,3.8,3.8,0,0,0,1.23.85,1.5,1.5,0,0,1,0,.2ZM50.78,41.55a3.68,3.68,0,0,1-.06-1.94A5.29,5.29,0,0,0,51,41.36Zm3.47-.61a3.83,3.83,0,0,1-2,.21h0l.15-.2A5,5,0,0,0,54.25,40.94Zm-1.09-2.42a3.54,3.54,0,0,1-.38-1.76,4.58,4.58,0,0,0,.49,1.59Zm1.82-3a3.64,3.64,0,0,1-.35-1.61,4.93,4.93,0,0,0,.45,1.42Zm1.68-3.57,0-.06a3.28,3.28,0,0,1-.77-1.59,4,4,0,0,0,.9,1.44A1.8,1.8,0,0,1,56.66,31.92ZM59.23,13c.57-.21,1.08-1.38,1.08-1.38A3,3,0,0,1,59.53,13c-.23.2.08.15.08.15,2.12-.74,1.23-3.32,1.16-3.37a4.47,4.47,0,0,1-1.06,1.34C58.86,11.83,59,13.1,59.23,13Z" />
							</svg>
							<div className="sitecore_item">
								<p className="text">国内導入実績</p>
								<p className="number">
									第
									<span className="count">
										{options.sitecoreNumber}
									</span>
									<span className="rank">位</span>
								</p>
							</div>
						</div>
					</div>
					<div className="numbers_item num_numberOnly num_growth">
						<div className="title">
							<p>売上高</p>
						</div>
						<div className="image">
							<svg
								class="svgIllust"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 512 512"
							>
								<g>
									<rect
										class="st0"
										x="37.774"
										y="366.201"
										width="104.106"
										height="145.748"
									></rect>
									<rect
										class="st0"
										x="183.482"
										y="282.967"
										width="104.106"
										height="229.033"
									></rect>
									<path
										class="st0"
										d="M473.224,151.045L387.663,3.68C386.341,1.403,383.901,0,381.278,0s-5.053,1.403-6.374,3.68l-85.567,147.365c-1.327,2.278-1.332,5.094-0.016,7.381c1.317,2.287,3.756,3.701,6.394,3.701h33.51V512h104.106V162.127h33.509c2.644,0,5.083-1.414,6.406-3.701C474.566,156.139,474.546,153.323,473.224,151.045z"
									></path>
								</g>
							</svg>
						</div>
						<div className="item">
							<div className="numberOnly_item">
								<p className="number">
									<span className="count">10</span>億
									<span className="_small">
										<span className="count">7500</span>万円
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="numbers_text">
				<p>※2025年度の実績です。</p>
			</div>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/Home/Numbers/Container.js